// extracted by mini-css-extract-plugin
export default {"container":"MedicalLayout_container__WL+CP","header":"MedicalLayout_header__6sBGl","logo":"MedicalLayout_logo__Rdlqc"};